import { createContext, useContext } from 'react';

interface LayoutContextType {
  isMobileBreakpoint: boolean;
  isMediumBreakpoint: boolean;
}

export const LayoutContext = createContext<LayoutContextType>({
  isMobileBreakpoint: false,
  isMediumBreakpoint: false
});

export const useLayout = () => {
  return useContext(LayoutContext);
};
